export default  {
  bindings: {
    category: '=',
    treatments: '<',
    days: '<',
    categories: '<'
  },
  controller: 'categoryFormController',
  template: require('../views/category.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/category.form.component.js